export default "__VITE_ASSET__mfUJrfeV__"